import { Flex } from "Element/Flex";
import styled from "styled-components";

export const StatusWrapper = styled(Flex)``;
